<button mat-icon-button (click)="exportar()" matTooltip="Exportar archivo" class="bounce-icon">
    <mat-icon class="bounce-icon"><span class="material-symbols-outlined">
file_save
</span></mat-icon>
  </button>
